export function renderGenGetBySlugContentServerActionTemplate({
  join,
  joinText,
  ctxCacheReadImport,
  ctxCamelPlural,
  ctxSingular,
  populateImport,
  authorshipAliasBlock,
  ctxCacheLifeLine,
  ctxSelectClause,
  ctxTableVar,
  ctxSingleRowReturn,
  ctxSingularText
}: {
  join: string
  joinText: string
  ctxCacheReadImport: string
  ctxCamelPlural: string
  ctxSingular: string
  populateImport: string
  authorshipAliasBlock: string
  ctxCacheLifeLine: string
  ctxSelectClause: string
  ctxTableVar: string
  ctxSingleRowReturn: string
  ctxSingularText: string
}): string {
  return `'use server'

import db from '@admin/db'
import { ${join} } from '@admin/db/schema'
import { ${joinText} } from 'drizzle-orm'
import { alias } from 'drizzle-orm/pg-core'
${ctxCacheReadImport}
import { ${ctxCamelPlural}CacheTags } from './types'
import type { ${ctxSingular} } from './types'${populateImport}

${authorshipAliasBlock}

export async function get${ctxSingular}BySlug(slug: string): Promise<${ctxSingular} | null> {
  'use cache'${ctxCacheLifeLine}
  cacheTag(${ctxCamelPlural}CacheTags.bySlug(slug))
  cacheTag(${ctxCamelPlural}CacheTags.all)

  try {
    const result = await ${ctxSelectClause}.where(eq(${ctxTableVar}.slug, slug)).limit(1)
    if (result.length === 0) return null
    ${ctxSingleRowReturn}
  } catch (error) {
    console.error('Error fetching ${ctxSingularText} by slug:', error)
    throw new Error('Failed to fetch ${ctxSingularText} by slug')
  }
}
`
}
